//import firebase from 'firebase'
// import 'firebase/firestore'

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
let firebase = require("firebase/app");

// Add the Firebase products that you want to use
require("firebase/auth");
require("firebase/firestore");

// The Cloud Functions for Firebase SDK to create Cloud Functions and setup triggers.
require('firebase/functions');


// Your web app's Firebase configuration
let firebaseConfig = {
    apiKey: "AIzaSyAgmWkBzFy8EUBdH4WkQHA0amgj3pEI3_Q",
    authDomain: "napolisotterranea-1124d.firebaseapp.com",
    databaseURL: "https://napolisotterranea-1124d.firebaseio.com",
    projectId: "napolisotterranea-1124d",
    storageBucket: "napolisotterranea-1124d.appspot.com",
    messagingSenderId: "760636885997",
    appId: "1:760636885997:web:d1b8c10b495ad8bd1b75e4",
    measurementId: "G-CES1CHJBBW"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.app().functions('europe-west3');
const currentUser = auth.currentUser;

// date issue fix according to firebase
const settings = {
    // timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
// const usersCollection = db.collection('users')
const eventsCollection = db.collection("events");
const guidesCollection = db.collection("guide");
const ticketsCollection = db.collection("tickets");
const usersCollection = db.collection("users");
const toursCollection = db.collection("tours");

export {
    firebase,
    db,
    auth,
    functions,
    currentUser,
    eventsCollection,
    guidesCollection,
    ticketsCollection,
    usersCollection,
    toursCollection
}
